import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"

import { HunkContentComponent } from "@/components/Diff/DiffHunkContent.tsx"
import { Horizontal } from "@/components/Flex.ts"

import type { DiffTheme } from "@/components/Diff/diffColors.ts"
import type { DiffExpandSide } from "@/components/Diff/diffTypes.ts"
import type { IntRange } from "@/lib/diff/misc.ts"
import type { Property } from "csstype"
import type { IObservableValue } from "mobx"


export const DiffHunkComponent = observer((props: {
  range: IntRange
  theme: DiffTheme
  gutterWidth: IObservableValue<Property.Width>

  expand: (side: DiffExpandSide, step?: number) => void
}) => {
  return (
    <Container backgroundColor={props.theme.line()}>
      <ExpandSide isTop onClick={() => props.expand("top")} />

      <HunkContentComponent range={props.range} gutterWidth={props.gutterWidth} expand={props.expand} />

      <ExpandSide isTop={false} onClick={() => props.expand("bottom")} />
    </Container>
  )
})

const Container = styled(Horizontal)<{ backgroundColor: Property.BackgroundColor }>`
  align-items: center;

  position: sticky;
  left: 0;

  height: 32px;

  color: var(--secondary-text-color);
  background-color: ${props => props.backgroundColor};

  user-select: none;
`

const ExpandSide = styled.div<{ isTop: boolean }>`
  position: absolute;
  width: 100%;
  height: 50%;

  top: ${props => props.isTop ? "0" : "auto"};
  bottom: ${props => props.isTop ? "auto" : "0"};

  border-color: var(--separator-color);
  border-style: solid;
  border-width: ${props => props.isTop ? "1px 0 0" : "0 0 1px"};

  cursor: pointer;

  &:hover {
    border-width: ${props => props.isTop ? "3px 0 0" : "0 0 3px"};
    border-color: var(--main-color);
  }
`